module.exports = __webpack_public_path__ + "static/3s-77347a53f9c50c29a454ca37d8cf72c0.jpg";